import { useEffect, useMemo, useState } from "react";
import { useServerApi } from "./userServerApi";
import { buildExchangeRateMap } from "../helpers/arFormInvestmentAmountUtils";

export const useInternalExchangeRates = () => {
  const [api] = useServerApi();
  const [rateMap, setRateMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await api.search({
          apiEntity: "exchangeRate",
          searchQuery: { active: true },
          pageSize: 1,
        });
        if (cancelled) return;
        const rates = result?.docs?.[0]?.rates ?? [];
        setRateMap(buildExchangeRateMap(rates));
      } catch (err) {
        if (!cancelled) {
          setRateMap({});
          setError(err?.message ?? "Failed to load exchange rates");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(
    () => ({
      rateMap,
      loading,
      error,
    }),
    [rateMap, loading, error]
  );
};
